// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"1a2649c7","456":"8b665689","656":"40781547","756":"e97aebf3","968":"98363f39"}[chunkId] + ".chunk.js";
};